<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Data Pelanggan</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formNewUserActive=!formNewUserActive">Tambah Pelanggan Baru
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formNewUserActive">
						<div class="row mt-3 p-3 mx-2 bg-white shadow">
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Tipe Pelanggan <span style="color:red;">*</span></label>
								<smart-select name="client_type" :options="newClientOption.clientTypes"
								              v-on:update="updateClientType"></smart-select>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">ID Pelanggan <span style="color:red;">*</span></label>
								<input type="number" class="form-control w-100 rounded" :min="1" :max="5"
								       v-model="newClient.idKlien"/>
								<small class="text-danger" v-show="isAddIdKlienLength">ID Pelanggan Minimum 3
									Digit</small>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Nama <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newClient.firstName"
								       @input="autoFillLegalName"/>
							</div>
							<div class="mt-2" :class="newClientCol" v-if="isNewBadan">
								<label class="d-block">Nama Belakang</label>
								<input type="text" class="form-control w-100 rounded" v-model="newClient.lastName"
								       @input="autoFillLegalName"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Nama Legal <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newClient.legalName"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Telp Pelanggan</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newClient.telephonePemilik"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Tambah Phone</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newClient.telephoneSecondaryPemilik"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Telp Pelanggan (PIC)</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newClient.telephonePengurus"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Email</label>
								<input type="text" class="form-control w-100 rounded" v-model="newClient.email"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">NPWP</label>
								<input type="text" id="newNPWP" class="form-control w-100 rounded"
								       v-model="newClient.npwp" @input="convertNewNPWP"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Identitas Penanggung Jawab</label>
								<smart-select name="client_identity" :options="newClientOption.identityTypes"
								              v-on:update="updateClientIdentityType"></smart-select>
							</div>
							<!-- <div class="mt-2" :class="newClientCol">
								<label class="d-block">Tipe induk</label>
								<smart-select name="client_induk" :options="newClientOption.clientTypes" v-on:update="updateClientIndukType"></smart-select>
							</div> -->
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">No Identitas Penanggung Jawab</label>
								<input type="number" :min="1" :max="16" class="form-control w-100 rounded"
								       v-model="newClient.identityNo"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">SIUP</label>
								<input type="text" class="form-control w-100 rounded" v-model="newClient.siup"/>
							</div>
							<div class="mt-2" :class="newClientCol">
								<label class="d-block">Alamat</label>
								<textarea type="text" class="form-control w-100 rounded" v-model="newClient.address"/>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewUser">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal menyimpan pelanggan baru.</p>
										</div>
										<div v-for="err in errorNewUserList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="savingNewPengguna">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button" v-on:click="saveNewUser">
									Submit
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :datas="users" :structure="userTableStructure" :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-seeker seeker-url="/api/master/seeker/klien"
					           @refetch="(row)=>{rowLimit=row;getUsers()}"
					           @searching="(val)=>!val.status?getUsers():users=val.data"
					           @change-url="(url)=>getUsers(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3">
											<small class="my-0 py-0">ID Pelanggan:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.customer_id }}</b>
										</div>
										<hr cllass="my-2">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3">
											<small class="my-0 py-0">Nama:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.first_name }}
											{{ obj.last_name ? obj.last_name : "" }}</b>
										</div>

									</li>
									<li class="mt-2">
										<div class="text-left mx-3">
											<small class="my-0 py-0">Nama legal:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.legal_name ? obj.legal_name : "-"
											}}</b>
										</div>
										<hr cllass="my-2">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3">
											<b-button v-b-modal.modal-detail-klien class="btn btn-primary mr-2 mb-1"
											          v-on:click="selectedDetail=index">
												<b-icon icon="eye"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-edit-user class="btn btn-info mr-2 mb-1"
											          v-on:click="selectedClient=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger mb-1">
												<b-icon icon="trash"></b-icon>
											</b-button>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.customer_id }}</td>
							<td v-if="!isMobile">{{ obj.first_name }}</td>
							<td v-if="!isMobile">{{ obj.last_name ? obj.last_name : "-" }}</td>
							<td v-if="!isMobile">{{ obj.legal_name ? obj.legal_name : "-" }}</td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-detail-klien class="btn btn-primary mr-2 mb-1"
								          v-on:click="selectedDetail=index">
									<b-icon icon="eye"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-edit-user class="btn btn-info mr-2 mb-1"
								          v-on:click="selectedClient=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger mb-1">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

			</div>
		</div>

		<!-- MODAL CLIENT -->
		<!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-user" title="Konfirmasi hapus data pengguna" scrollable no-close-on-backdrop @hide="deleteModalClose">
			<b-container fluid v-if="!loadData">
				<b-row class="pt-1">
				  <b-col cols="12" class="my-3">
					  <h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
					  <ul>
						  <li>Nama depan: {{users[selectedToDelete].first_name}}</li>
						  <li>Nama belakang: {{users[selectedToDelete].last_name}}</li>
						  <li>Nama legal: {{users[selectedToDelete].legal_name}}</li>
					  </ul>
				  </b-col>
				   <b-col cols="12" class="my-3 text-right"  v-if="deleteUserState">
					   <div class="d-flex align-items-center justify-content-start">
							<div class="spinner-border" role="status" aria-hidden="true"></div>
							<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
						</div>
					</b-col>
					<div class="col-12 mt-3"  v-if="userDeleted">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-success" role="alert">
								Berhasil menghapus data klien.
							</div>
						</div>
					</div>
					<div class="col-12 mt-3"  v-if="failDeleteUser">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-danger" role="alert">
								Gagal menghapus data klien.
							</div>
						</div>
					</div>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
				<hr>
				<button class="btn btn-danger  mr-2" v-on:click="deleteClientData">Ya, hapus</button>
				<b-button class="btn btn-secondary" @click="(!deleteUserState)?$bvModal.hide('modal-delete-user'):''">Tutup</b-button>
				</div>
			</template>
		</b-modal> -->

		<b-modal no-close-on-esc content-class="m-0" id="modal-detail-klien" scrollable no-close-on-backdrop
		         @hide="detailModalClose">
			<b-container fluid v-if="!loadData&&users.length>0">
				<b-row class="pt-1" v-if="users[selectedDetail]!=undefined">
					<b-col cols="12">
						<table v-if="users.length>0" rules="rows" class="table w-100">
							<tbody>
							<tr>
								<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt" colspan="2"
								    scope="row">Detail Pelanggan
								</th>
							</tr>
							<tr>
								<th class="" scope="row">Tipe Pelanggan</th>
								<td class="">
									{{
										users[selectedDetail].type == "Badan" ? "Non Perorangan" : users[selectedDetail].type
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">ID Pelanggan</th>
								<td class="">{{ users[selectedDetail].customer_id }}</td>
								<!-- <td class="">{{users[selectedDetail].hardware_setup!=null?users[selectedDetail].hardware_setup.id_transmitter:'-'}}</td> -->
							</tr>
							<tr>
								<th class="" scope="row">Nama</th>
								<td class="">{{ users[selectedDetail].first_name }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Nama Belakang</th>
								<td class="">
									{{ users[selectedDetail].last_name ? users[selectedDetail].last_name : "-" }}
								</td>
								<!-- <td class="">{{ users[selectedDetail].client?users[selectedDetail].client.legal_name!=null?users[selectedDetail].client.legal_name:'-':'-'}}</td> -->
							</tr>
							<tr>
								<th class="" scope="row">Nama Legal</th>
								<td class="">
									{{ users[selectedDetail].legal_name ? users[selectedDetail].legal_name : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Telp Pelanggan</th>
								<td class="">
									{{
										users[selectedDetail].telephone_pemilik ? users[selectedDetail].telephone_pemilik : "-"
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Tambah Phone</th>
								<td class="">
									{{
										users[selectedDetail].telephone_pemilik_secondary ? users[selectedDetail].telephone_pemilik_secondary : "-"
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Telp Pelanggan (PIC)</th>
								<td class="">
									{{
										users[selectedDetail].telephone_pengurus ? users[selectedDetail].telephone_pengurus : "-"
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Email</th>
								<td class="">{{ users[selectedDetail].email ? users[selectedDetail].email : "-" }}</td>
							</tr>
							<tr>
								<th class="" scope="row">NPWP</th>
								<td class="">{{ users[selectedDetail].npwp ? users[selectedDetail].npwp : "-" }}</td>
							</tr>
							<tr>
								<th class="" scope="row">SIUP</th>
								<td class="">{{ users[selectedDetail].siup ? users[selectedDetail].siup : "-" }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Identitas Penanggung Jawab</th>
								<td class="">{{ users[selectedDetail].identity }}</td>
							</tr>
							<tr>
								<th class="" scope="row">No Identitas Penanggung Jawab</th>
								<td class="">
									{{ users[selectedDetail].identity_no ? users[selectedDetail].identity_no : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Alamat</th>
								<td class="">{{ users[selectedDetail].address ? users[selectedDetail].address : "-" }}
								</td>
							</tr>

							</tbody>

						</table>
					</b-col>

				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<b-button class="btn btn-secondary"
					          @click="(!deleteUserState)?$bvModal.hide('modal-detail-klien'):''">Tutup
					</b-button>
				</div>
			</template>
		</b-modal>

		<b-modal no-close-on-esc content-class="m-0" id="modal-edit-user" title="Detail informasi user" scrollable
		         no-close-on-backdrop size="lg" @hide="editModalClose">
			<b-container fluid v-if="!loadData">
				<b-row class="mt-3 pt-1" v-if="users[selectedClient]!=undefined">
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Tipe Pelanggan</label>
						<smart-select name="client_type" :options="newClientOption.clientTypes"
						              v-on:update="(value)=>{users[selectedClient].type=value}"></smart-select>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">ID Pelanggan</label>
						<input type="number" class="form-control w-100 rounded" min="1" max="5"
						       v-model="users[selectedClient].customer_id"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Nama</label>
						<input type="text" class="form-control w-100 rounded" v-model="users[selectedClient].first_name"
						       @input="autoFillLegalName"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Nama Belakang</label>
						<input type="text" class="form-control w-100 rounded" v-model="users[selectedClient].last_name"
						       @input="autoFillLegalName"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Nama Legal</label>
						<input type="text" class="form-control w-100 rounded" v-model="users[selectedClient].legal_name"
						       readonly/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Telp Pelanggan</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="users[selectedClient].telephone_pemilik"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Tambah Phone</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="users[selectedClient].telephone_pemilik_secondary"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Telp Pelanggan (PIC)</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="users[selectedClient].telephone_pengurus"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Email</label>
						<input type="text" class="form-control w-100 rounded" v-model="users[selectedClient].email"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">NPWP</label>
						<input type="text" id="editNPWP" class="form-control w-100 rounded"
						       v-model="users[selectedClient].npwp" @input="convertEditNPWP"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Identitas Penanggung Jawab</label>
						<smart-select name="client_identity" :options="newClientOption.identityTypes"
						              v-on:update="(value)=>{users[selectedClient].identity=value}"></smart-select>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">No Identitas Penanggung Jawab</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="users[selectedClient].identity_no"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">SIUP</label>
						<input type="text" class="form-control w-100 rounded" v-model="users[selectedClient].siup"/>
					</b-col>
					<b-col cols="12" md="6" lg="4">
						<label class="d-block">Alamat</label>
						<textarea type="text" class="form-control w-100 rounded"
						          v-model="users[selectedClient].address"/>
					</b-col>
					<!-- <b-col :cols="updateClientCol">
						<label class="d-block">Tipe induk</label>
						<smart-select name="client_induk" :options="newClientOption.clientTypes" v-on:update="(value)=>{users[selectedClient].induk=value}"></smart-select>
					</b-col> -->
					<b-col cols="12" class="my-3 text-right" v-if="updateClientState">
						<div class="d-flex align-items-center justify-content-start">
							<div class="spinner-border" role="status" aria-hidden="true"></div>
							<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
						</div>
					</b-col>
					<div class="col-12 mt-3" v-if="updateClientSaved">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-success" role="alert">
								Berhasil update data pelanggan.
							</div>
						</div>
					</div>
					<div class="col-12 mt-3" v-if="errorClientSaved">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-danger" role="alert">
								Gagal update data pelanggan.
							</div>
						</div>
					</div>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<button class="btn btn-info mr-2" v-on:click="updateClientData">Submit</button>
					<b-button class="btn btn-secondary mr-2"
					          @click="(!updateUserState&&!updateClientState)?$bvModal.hide('modal-edit-user'):''">Tutup
					</b-button>
				</div>
			</template>
		</b-modal>

		<modal-delete url="/api/master/klien/" @read="()=>{console.log('modal ready')}" @result="deleteResult"
		              :targetid="deleteId">
			Yakin mau menghapus data dengan detail berikut :<br>
			<ul>
				<li>ID Pelanggan: {{ itemToDelete.customer_id }}</li>
				<li>Nama : {{ itemToDelete.first_name }}</li>
				<li>Nama Belakang: {{ itemToDelete.last_name ? itemToDelete.last_name : "-" }}</li>
				<li>Nama Legal: {{ itemToDelete.legal_name }}</li>
			</ul>
		</modal-delete>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			isAddIdKlienLength: false,
			//step 1 edit
			dataEdit: null,
			itemToDelete: {},
			deleteId: 0,
			users: [],
			searchValue: "",
			loadData: true,
			savingNewPengguna: false,
			errorNewUser: false,
			errorNewUserList: [],
			existingClientResult: [],
			newUserSaved: false,
			selectedClient: 0,
			selectedDetail: 0,
			updateUserSaved: false,
			errorUserSaved: false,
			updateUserState: false,
			updateClientSaved: false,
			errorClientSaved: false,
			updateClientState: false,
			deleteUserState: false,
			userDeleted: false,
			failDeleteUser: false,
			isNewBadan: false,
			selectedToDelete: 0,
			selectedAdmin: 0,
			existingClientQuery: {
				firstNameClientQuery: "",
				lastNameClientQuery: "",
				legalNameClientQuery: "",
				looking: false,
				nextQueue: false,
				waitForNext: false
			},
			newClientCol: "col-12 col-md-6 col-lg-4",
			updateClientCol: 6,
			updateAdminCol: 6,
			selectedTab: 0,
			newClient: {
				idKlien: "",
				firstName: "",
				lastName: "",
				legalName: "",
				telephonePemilik: "",
				telephoneSecondaryPemilik: "",
				telephonePengurus: "",
				email: "",
				npwp: "",
				siup: "",
				address: "",
				identity: "KTP",
				identityNo: "",
				npwp: "",
				type: "Badan"
				// induk:'Badan'
			},
			newClientOption: {
				identityTypes: [
					{label: "KTP", value: "KTP"},
					{label: "SIM", value: "SIM"},
					{
						label: "Passport", value: "Passport"
					}
				],
				clientTypes: [
					{label: "Non Perorangan", value: "Badan"},
					{
						label: "Perorangan", value: "Perorangan"
					}
				]
			},
			formNewUserActive: false,
			userTableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "ID Pelanggan", key: null},
				{label: "Nama", key: null},
				{label: "Nama Belakang", key: null},
				{label: "Nama Legal", key: null},
				{label: "Tindakan", key: null}
			],
			number: {
				numberId: 5
			}
			// userRoleOptions:[
			//     {label:'Admin',value:'admin'},
			//     {label:'Klien ',value:'client'},
			//     {label:'Supervisor ',value:'Supervisor'},
			// ]
		};
	},
	created() {
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getUsers();
		this.setNPWP();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/klien?limit=" + this.rowLimit + "&page=" + myParams;
			this.getUsers(newUrl);
		},
		autoFillLegalName() {
			this.newClient.legalName = this.newClient.firstName + " " + this.newClient.lastName;
			this.users[this.selectedClient].legal_name = this.users[this.selectedClient].first_name + " " + this.users[this.selectedClient].last_name;
		},
		// searchResult(data){
		//     if(data.status){
		//         console.log('has data')
		//         this.users=data.data
		//         console.log(this.users)
		//     }else{
		//         this.getUsers()
		//     }
		// },
		setNPWP(nodata = true, value = "") {
			var init = "";
			if (!nodata) {
				init = value;
			}
			for (var x = init.length; x < 15; x++) {
				init += "0";
			}
			this.newClient.npwp = init.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, "$1.$2.$3.$4-$5.$6");
		},
		convertNewNPWP() {
			var el = document.getElementById("newNPWP");
			this.newClient.npwp = this.newClient.npwp.replace(/\./gi, "");
			this.newClient.npwp = this.newClient.npwp.replace(/\-/gi, "");
			var index = el.selectionStart;

			if (index == 2 || index == 6 || index == 10 || index == 12 || index == 16) {
				index++;
			}
			console.log(this.newClient.npwp);
			if (this.newClient.npwp.length > 0 && this.newClient.npwp.length < 15) {
				console.log(this.newClient.npwp.length);
				for (var x = this.newClient.npwp.length; x < 15; x++) {

					this.newClient.npwp += "0";
				}
			}
			if (this.newClient.npwp.length > 15) {
				this.newClient.npwp = this.newClient.npwp.slice(0, 15);
			}
			this.newClient.npwp = this.newClient.npwp.replace(
				/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/,
				"$1.$2.$3.$4-$5.$6"
			);

			setTimeout(() => {

				el.focus();
				el.setSelectionRange(index, index);
			}, 0);
		},
		convertEditNPWP() {
			var el = document.getElementById("editNPWP");
			this.users[this.selectedClient].npwp = this.users[this.selectedClient].npwp.replace(/\./gi, "");
			this.users[this.selectedClient].npwp = this.users[this.selectedClient].npwp.replace(/\-/gi, "");
			var index = el.selectionStart;

			if (index == 2 || index == 6 || index == 10 || index == 12 || index == 16) {
				index++;
			}
			console.log(this.users[this.selectedClient].npwp);
			if (this.users[this.selectedClient].npwp.length > 0 && this.users[this.selectedClient].npwp.length < 15) {
				console.log(this.users[this.selectedClient].npwp.length);
				for (var x = this.users[this.selectedClient].npwp.length; x < 15; x++) {

					this.users[this.selectedClient].npwp += "0";
				}
			}
			if (this.users[this.selectedClient].npwp.length > 15) {
				this.users[this.selectedClient].npwp = this.users[this.selectedClient].npwp.slice(0, 15);
			}
			this.users[this.selectedClient].npwp = this.users[this.selectedClient].npwp.replace(
				/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/,
				"$1.$2.$3.$4-$5.$6"
			);

			setTimeout(() => {

				el.focus();
				el.setSelectionRange(index, index);
			}, 0);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getUsers();
			}
		},
		getUsers(url = (this.$baseUrl + "/api/master/klien?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.users = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		saveNewUser() {
			this.isAddIdKlienLength = false;
			if (this.newClient.idKlien != "" && this.newClient.idKlien.length < 3) {
				this.isAddIdKlienLength = true;
				return;
			}
			this.savingNewPengguna = true;
			this.errorNewUser = false;
			console.log(this.newUser);
			if (
				this.newClient.idKlien == "" &&
				this.newClient.firstName == "" &&
				this.newClient.legalName == ""
			) {
				this.errorNewUser = true;
				this.savingNewPengguna = false;
				this.errorNewUserList = [];
				if (this.newClient.idKlien == "") {
					this.errorNewUserList.push(["- Mohon Isi ID Pelanggan"]);
				}
				if (this.newClient.firstName == "") {
					this.errorNewUserList.push(["- Mohon Isi Nama Pelanggan"]);
				}
				if (this.newClient.legalName == "") {
					this.errorNewUserList.push(["- Mohon Isi Nama Legal Pelanggan"]);
				}
				console.log(this.errorNewUserList);
				return;
			}
			axios.post(
				this.$baseUrl + "/api/master/klien",
				{
					customer_id: this.newClient.idKlien,
					first_name: this.newClient.firstName,
					last_name: this.newClient.lastName,
					legal_name: this.newClient.legalName,
					telephone_pemilik: this.newClient.telephonePemilik,
					telephone_pemilik_secondary: this.newClient.telephoneSecondaryPemilik,
					telephone_pengurus: this.newClient.telephonePengurus,
					email: this.newClient.email,
					npwp: this.newClient.npwp,
					siup: this.newClient.siup,
					address: this.newClient.address,
					identity: this.newClient.identity,
					identity_no: this.newClient.identityNo,
					type: this.newClient.type
					// induk:this.newClient.induk,

				},
				{
					"headers":
						{
							"Authorization": "Bearer " + localStorage.getItem("accessToken")
						}
				}
			).then((result) => {
				//console.log(result)
				if (result.data.create) {
					this.getUsers();
				}
				this.savingNewPengguna = false;
				this.newUserSaved = true;

				setTimeout(() => {
					this.newUserSaved = false;
					this.formNewUserActive = false;
				}, 1000);

			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.errorNewUserList = [];
				this.errorNewUserList = Object.values(err.response.data.errors);
				console.log(this.errorNewUserList);
				this.errorNewUser = true;
				this.savingNewPengguna = false;
			});
		},
		deleteItem(idx) {
			this.selectedToDelete = idx;
		},
		// updateUserRoleValue(newValue){
		//     this.newUser.role=newValue
		// },
		updateClientIdentityType(newValue) {
			this.newUser.newClient.identity = newValue;
		},
		updateClientType(newValue) {
			this.newClient.type = newValue;
			if (newValue == "Perorangan") {
				this.isNewBadan = true;
			} else {
				this.isNewBadan = false;
			}
		},
		updateClientIndukType(newValue) {
			this.newClient.induk = newValue;
		},
		recallClientSearch() {
			//this.existingClientQuery.waitForNext=true;
			console.log("asign new queue");
			setTimeout(() => {
				console.log("recall");
				if (!this.existingClientQuery.looking) {
					this.existingClientQuery.nextQueue = false;
					this.searchExistingClientChangeEvent();
				} else {
					console.log("queue exist, current process still running, retry later");
					this.recallClientSearch();
				}
			}, 1000);
		},
		searchExistingClientChangeEvent() {
			if (this.existingClientQuery.looking && !this.existingClientQuery.nextQueue) {
				this.existingClientQuery.nextQueue = true;
				this.recallClientSearch();
				return;
			} else if (!this.existingClientQuery.looking && this.existingClientQuery.nextQueue) {
				return;
			}


			if (this.existingClientQuery.firstNameClientQuery != "" || this.existingClientQuery.lastNameClientQuery != "" || this.existingClientQuery.legalNameClientQuery != "") {
				var data = {
					first_name: this.existingClientQuery.firstNameClientQuery,
					last_name: this.existingClientQuery.lastNameClientQuery,
					legal_name: this.existingClientQuery.legalNameClientQuery
				};
				console.log(data);
				this.existingClientQuery.looking = true;
				axios.post(
					this.$baseUrl + "/api/master/seeker/klien",
					{
						first_name: this.existingClientQuery.firstNameClientQuery,
						last_name: this.existingClientQuery.lastNameClientQuery,
						legal_name: this.existingClientQuery.legalNameClientQuery
					},
					{
						"headers": {
							"Authorization": "Bearer " + localStorage.getItem("accessToken")
						}
					}
				).then((result) => {
					this.existingClientQuery.looking = false;
					if (!this.existingClientQuery.nextQueue) {
						console.log("no Queue");
						this.existingClientResult = result.data;
					}
					//console.log(result)
				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					//console.log(err)
					this.existingClientQuery.nextQueue = false;
					this.existingClientQuery.looking = false;
				});
			} else {
				this.existingClientQuery.looking = false;
				this.existingClientQuery.nextQueue = false;
			}
		},
		setNewClientId(newId) {
			this.newUser.clientId = newId;
			console.log(this.newUser.clientId);
		},
		deleteClientData() {
			console.log("deleting data");
			this.deleteUserState = true;
			axios.delete(this.$baseUrl + "/api/master/klien/" + this.users[this.selectedToDelete].id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				if (result.status == 200) {
					this.deleteUserState = false;
					this.userDeleted = true;

					setTimeout(() => {
						this.users.splice(this.selectedToDelete, 1);
						this.$bvModal.hide("modal-delete-user");
						this.userDeleted = false;
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteUserState = false;
				this.failDeleteUser = true;
				setTimeout(() => {
					this.failDeleteUser = false;
				}, 1000);
				console.log(err);
			});
		},

		updateClientData() {
			console.log("updating data");
			this.updateClientState = true;
			axios.put(this.$baseUrl + "/api/master/klien/" + this.users[this.selectedClient].id, {
				customer_id: this.users[this.selectedClient].customer_id,
				first_name: this.users[this.selectedClient].first_name,
				last_name: this.users[this.selectedClient].last_name,
				legal_name: this.users[this.selectedClient].legal_name,
				telephone_pemilik: this.users[this.selectedClient].telephone_pemilik,
				telephone_pengurus: this.users[this.selectedClient].telephone_pengurus,
				telephone_pemilik_secondary: this.users[this.selectedClient].telephone_pemilik_secondary,
				email: this.users[this.selectedClient].email,
				npwp: this.users[this.selectedClient].npwp,
				siup: this.users[this.selectedClient].siup,
				address: this.users[this.selectedClient].address,
				identity: this.users[this.selectedClient].identity,
				identity_no: this.users[this.selectedClient].identity_no,
				type: this.users[this.selectedClient].type
				// induk:this.users[this.selectedClient].induk,

			}, {
				          "headers": {
					          "Authorization": "Bearer " + localStorage.getItem("accessToken")
				          }
			          }).then((result) => {
				if (result.status == 200) {
					this.updateClientState = false;
					this.updateClientSaved = true;
					//step 4 edit
					this.dataEdit = this.users[this.selectedClient];
					setTimeout(() => {
						this.updateUserSaved = false;
						this.updateClientSaved = false;
						this.$bvModal.hide("modal-edit-user");
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updateClientState = false;
				this.errorClientSaved = true;
				setTimeout(() => {
					this.errorClientSaved = false;
				}, 1000);
				console.log(err.response);
			});
		},
		detailModalClose(mdl) {
			if (this.updateUserState || this.updateClientState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-klien");
			}
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.users, this.selectedClient, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updateUserState || this.updateClientState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-user");
			}
		},
		deleteModalClose(mdl) {
			if (this.deleteUserState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-user");
			}
		}

	}
};
</script>
<style>
/** TEXT CENTER UNTUK SEMUA TABLE **/
.table th, .table td {
	text-align: center;
}
</style>

<style scoped>
.modal.show .modal-dialog {
	transform: none;
	-webkit-transform: none;
}

.btn {
	padding: 2px 6px;
}

::v-deep .modal-content {
	margin: -7.25rem auto;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 50%;
}
</style>


